import {
  linkInvestorAnnualReport,
  linkInvestorDisclosure,
  linkInvestorDividendPolicy,
  linkInvestorFinancialInformationReport,
  linkInvestorIrActivities,
  linkInvestorProspectus,
  linkInvestorShareholderInfo,
  linkInvestorSupplementaryInformationChild,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"

export const investorsAreaList = [
  {
    title_en: translations.prospectus_en,
    title_id: translations.prospectus_id,
    link: linkInvestorProspectus,
  },
  {
    title_en: translations.financial_information_en,
    title_id: translations.financial_information_id,
    link: linkInvestorFinancialInformationReport,
    parent: "financial-information",
  },
  {
    title_en: translations.disclosure_en,
    title_id: translations.disclosure_id,
    link: linkInvestorDisclosure,
  },
  {
    title_en: translations.annual_report_en,
    title_id: translations.annual_report_id,
    link: linkInvestorAnnualReport,
  },
  {
    title_en: translations.shareholder_information_en,
    title_id: translations.shareholder_information_id,
    link: linkInvestorShareholderInfo,
  },
  {
    title_en: translations.dividend_en,
    title_id: translations.dividend_id,
    link: linkInvestorDividendPolicy,
    parent: "dividend",
  },
  {
    title_en: translations.ir_activities_en,
    title_id: translations.ir_activities_id,
    link: linkInvestorIrActivities,
  },
  {
    title_en: translations.supplementary_information_en,
    title_id: translations.supplementary_information_id,
    link: linkInvestorSupplementaryInformationChild,
    parent: "supplementary-information",
  },
]
